import { render, staticRenderFns } from "./FormatMultiPageSelector.vue?vue&type=template&id=242a7ed1&scoped=true&"
import script from "./FormatMultiPageSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatMultiPageSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatMultiPageSelector.vue?vue&type=style&index=0&id=242a7ed1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a7ed1",
  null
  
)

export default component.exports